/**
 * @returns {boolean}
 */
export function isPopoverSupported() {
  return 'popover' in HTMLElement.prototype;
}

/**
 * @param {HTMLElement} element
 * @param {Function} callback
 * @param {Object} options
 */
export function whenStuck(element, callback, options = {}) {
  options = Object.assign({
    offset: 0,
  }, options);

  const watcher = document.createElement('div');
  watcher.setAttribute('data-scroll-watcher', '');

  const observer = new IntersectionObserver(([entry]) => {
    callback(
      !entry.isIntersecting,
      entry.target
    );
  }, {
    rootMargin: `${options.offset}px 0px 0px 0px`,
  });

  element.before(watcher);
  observer.observe(watcher);
}